import { gql } from '@apollo/client';
/**
 * Gift recipient of a public deal (store confirmation). Kept out of
 * DealPublicQuery so a backend without these fields only hides the gift
 * details instead of failing the whole deal query.
 * @const DealGiftPublicQuery
 * @since 1.0.0
 */
export const DealGiftPublicQuery = gql `
  query DealGiftPublicQuery($input: DealInput!) {
    deal(input: $input) {
      id
      giftToName
      giftToEmail
      giftSendAt
    }
  }
`;
